import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { analytics } from '../config/firebase';

// Analytics helper functions
export const trackPageView = (pageName: string) => {
  if (analytics && typeof window !== 'undefined') {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }
};

export const trackUserLogin = (method: string) => {
  if (analytics) {
    logEvent(analytics, 'login', {
      method: method
    });
  }
};

export const trackUserSignUp = (method: string) => {
  if (analytics) {
    logEvent(analytics, 'sign_up', {
      method: method
    });
  }
};

export const trackApiaryCreated = () => {
  if (analytics) {
    logEvent(analytics, 'apiary_created', {
      content_type: 'beekeeping'
    });
  }
};

export const trackHiveCreated = () => {
  if (analytics) {
    logEvent(analytics, 'hive_created', {
      content_type: 'beekeeping'
    });
  }
};

export const trackInspectionCompleted = (inspectionType: string, hasAI: boolean) => {
  if (analytics) {
    logEvent(analytics, 'inspection_completed', {
      inspection_type: inspectionType,
      ai_analysis: hasAI
    });
  }
};

export const trackAIAnalysisUsed = () => {
  if (analytics) {
    logEvent(analytics, 'ai_analysis_used', {
      feature: 'hive_inspection_ai'
    });
  }
};

export const trackBeeBaseAlertViewed = () => {
  if (analytics) {
    logEvent(analytics, 'beebase_alert_viewed', {
      content_type: 'disease_alert'
    });
  }
};

export const trackDataExport = (exportType: string) => {
  if (analytics) {
    logEvent(analytics, 'data_export', {
      export_type: exportType
    });
  }
};

export const setAnalyticsUserId = (userId: string) => {
  if (analytics) {
    setUserId(analytics, userId);
  }
};

export const setAnalyticsUserProperties = (properties: { [key: string]: any }) => {
  if (analytics) {
    setUserProperties(analytics, properties);
  }
};